import { Routes, Route, NavLink, useLocation } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { Admin } from './pages/Admin';
import { AdminRooms } from './pages/AdminRooms';
import { AdminDevices } from './pages/AdminDevices';
import { AdminHealth } from './pages/AdminHealth';
import { Kiosk } from './pages/Kiosk';

export function App() {
  // Kiosk routes render full-screen — no topbar, no chrome. Everything else
  // gets the management-UI shell.
  const isKiosk = useLocation().pathname.startsWith('/kiosk');

  if (isKiosk) {
    return (
      <Routes>
        <Route path="/kiosk" element={<Kiosk />} />
      </Routes>
    );
  }

  return (
    <>
      <nav className="topbar">
        <NavLink to="/" end className="brand">
          <img className="brand-logo" src="/brand/wic-logo-red.png" alt="WIC" width={616} height={252} />
          Conf
        </NavLink>
        <div className="spacer" />
        <NavLink to="/admin">Admin</NavLink>
      </nav>
      <main>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/rooms" element={<AdminRooms />} />
          <Route path="/admin/devices" element={<AdminDevices />} />
          <Route path="/admin/health" element={<AdminHealth />} />
        </Routes>
      </main>
    </>
  );
}
